/**
 * Created by Andste on 2018/7/2.
 * buyer_pc : 买家PC端
 * buyer_wap: 买家WAP端
 * seller   : 商家中心
 * admin    : 后台管理
 */


module.exports = {
  // 开发环境
  dev: {
    buyer_pc : 'http://127.0.0.1:3000',
    buyer_wap: 'http://127.0.0.1:3001',
    seller   : 'http://127.0.0.1:3002',
    admin    : 'http://127.0.0.1:3003'
  },
  // 测试环境
  test: {
    buyer_pc : 'https://buyer.shop.frontsea-iplus.com',
    buyer_wap:  'https://m.shop.frontsea-iplus.com',
    seller   : 'https://seller.shop.frontsea-iplus.com',
    admin    :  'https://admin.shop.frontsea-iplus.com'
  },
  // 生产环境
  pro: {
    buyer_pc : 'https://buyer.shop.frontsea-iplus.com',
    buyer_wap:  'https://m.shop.frontsea-iplus.com',
    seller   : 'https://seller.shop.frontsea-iplus.com',
    admin    :  'https://admin.shop.frontsea-iplus.com'
    // buyer_pc : env.DOMAIN_BUYER_PC || 'https://pc-shopdev.shop.frontsea-iplus.com',
    // buyer_wap: env.DOMAIN_BUYER_WAP || 'https://m-shopdev.shop.frontsea-iplus.com',
    // seller   : env.DOMAIN_SELLER || 'https://seller-shopdev.shop.frontsea-iplus.com',
    // admin    : env.DOMAIN_ADMIN || 'https://admin-shopdev.shop.frontsea-iplus.com'
  }
}




//////////////////
// WEBPACK FOOTER
// ./ui-domain/domain.js
// module id = Xk9X
// module chunks = 101